import Swiper, { Navigation } from 'swiper';
import gsap from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';

const CollectionCarousel = () => {
  const sections = document.querySelectorAll('.collection-carousel');
  Swiper.use([Navigation]);

  const initSwiper = (section, swiperEl) => {

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    let slidesWidth = 0;
    slides.forEach((slide) => {
        slidesWidth += slide.offsetWidth + 10;
    });

    const prevEl = section.querySelector( '.swiper-button-prev' );
    const nextEl = section.querySelector( '.swiper-button-next' );
    const swiper = new Swiper(swiperEl, {
        spaceBetween: 10,
        slidesPerView: 'auto',
        centeredSlides: true,
        watchOverflow: true,
        initialSlide: Math.floor(slides.length / 2),
        navigation: {
          nextEl,
          prevEl
        },
    });

    if (slidesWidth < window.innerWidth) {
        swiperEl.classList.add('is-centered');
        swiper.params.centeredSlides = false;
        swiper.disable();
    }
    
    lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
        if (window.innerWidth === lastWidth) {
            return;
        }
        if (slidesWidth < window.innerWidth && slidesWidth >= lastWidth) {
            swiperEl.classList.add('is-centered');
            swiper.params.centeredSlides = false;
            swiper.disable();
        } else if (slidesWidth >= window.innerWidth && slidesWidth < lastWidth) {
            swiperEl.classList.remove('is-centered');
            swiper.params.centeredSlides = true;
            swiper.enable();
            setTimeout(() => {
                swiper.slideTo(Math.floor(slides.length / 2));
            })
        }
        lastWidth = window.innerWidth;
    })
  }

  const initCurvedSwiper = (section, swiperEl) => {
    const prevEl = section.querySelector( '.swiper-button-prev' );
    const nextEl = section.querySelector( '.swiper-button-next' );
    const swiper = new Swiper(swiperEl, {
      loop: true,
      spaceBetween: 0,
      slidesPerView: 1.5,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl,
        prevEl
      },
    });

    windowWidthCenter = window.innerWidth / 2;

    const update = () => {
      swiper.slides.forEach((slide) => {
        if (window.innerWidth < 768) {
          slide.style.transform = `translateY(0px)`;
          return;
        }

        const rect = slide.getBoundingClientRect();
        if (rect.x > window.innerWidth || rect.x + rect.width < 0) return;
        let yVal = Math.abs(windowWidthCenter - rect.x - rect.width / 2);
        yVal = (yVal) * (yVal) / (window.innerWidth * 2);
        slide.style.transform = `translateY(${yVal}px)`;
      })

      requestAnimationFrame(update);
    }
  
    requestAnimationFrame(update);

    window.addEventListener('resize', () => {
      windowWidthCenter = window.innerWidth / 2;
    })
  }

  const initScroller = (section, scrollerEl) => {
    const scroller = section.querySelector('.scroller')
    const container = section.querySelector('.container-fluid')
    
    if (!scrollerEl || !scroller || !container) return;
    const slides = scroller.querySelectorAll('.item');

    gsap.registerPlugin(ScrollTrigger);

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: scrollerEl,
        start: 'top bottom',
        end: 'bottom -20vw',
        scrub: .5,
        invalidateOnRefresh: true,
      },
    });

    tl.to(scroller, {
      x: () => {
        if (scroller.offsetWidth < scrollerEl.offsetWidth) return 0;
        return -(scroller.offsetWidth - window.innerWidth) + 'px'
      }
    })

    let curPadding = 0;
    const updateScroller = () => {
      if (scroller.offsetWidth - curPadding < scrollerEl.offsetWidth) {
        scroller.style.paddingLeft = '2.25rem'
        scroller.style.paddingRight = '2.25rem'
        scrollerEl.style.height = window.innerHeight + 'px'
        scrollerEl.classList.add('fit')
        curPadding = 0;
      } else {
        scrollerEl.classList.remove('fit')
        curPadding = (window.innerWidth - container.offsetWidth) / 2 + 12
        const lastSlideWidth = slides[slides.length - 1].offsetWidth
        if (window.innerWidth < 768) {
          scroller.style.paddingLeft = ((window.innerWidth - container.offsetWidth)) / 2 + 12 + window.innerWidth * 2 + 'px'
          scroller.style.paddingRight = (window.innerWidth - container.offsetWidth) / 2 + 12 + ((window.innerWidth - lastSlideWidth) / 2) + 'px'
        } else {
          scroller.style.paddingLeft = ((window.innerWidth - container.offsetWidth)) / 2 + 12 + window.innerWidth + 'px'
          scroller.style.paddingRight = (window.innerWidth - container.offsetWidth) / 2 + 12 + ((window.innerWidth - lastSlideWidth) / 2) + 'px'
        }
        scrollerEl.style.height = Math.max(scroller.offsetWidth, window.innerHeight) + 'px'
      }
    }

    updateScroller();

    windowWidthCenter = window.innerWidth / 2;
    const update = () => {
      slides.forEach((slide) => {
        if (window.innerWidth < 768) {
          slide.style.transform = `translateY(0px)`;
          return;
        }

        const rect = slide.getBoundingClientRect();
        if (rect.x > window.innerWidth || rect.x + rect.width < 0) return;
        let yVal = Math.abs(windowWidthCenter - rect.x - rect.width / 2);
        yVal = (yVal) * (yVal) / (window.innerWidth * 2);
        slide.style.transform = `translateY(${yVal}px)`;
      })

      requestAnimationFrame(update);
    }
  
    requestAnimationFrame(update);
    
    window.addEventListener('resize', () => {
      updateScroller();
      windowWidthCenter = window.innerWidth / 2;
    })
  }

  for (const section of sections) {
    const swiperEl = section.querySelector('.slider .swiper');

    if (swiperEl) {
      initSwiper(section, swiperEl);
      continue;
    };

    const swiperCurvedEl = section.querySelector('.slider-curved .swiper');

    if (swiperCurvedEl) {
      initCurvedSwiper(section, swiperCurvedEl);
      continue;
    };

    const scrollerEl = section.querySelector('.scroller-wrapper');
    if (scrollerEl) {
      initScroller(section, scrollerEl);
    }
  }
}

export default CollectionCarousel;